module.exports = __webpack_public_path__ + "static/img/pavilion.901d70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pavilion.png
// module id = rIPg
// module chunks = 8